<div class="page-header">
  <h1 class="page-header__title">{{ date | date : "longDate" }}</h1>
  <h2>{{ "activity-schedule.choose-activity" | translate }}</h2>
</div>

<app-activity-schedule-overview-list [activitySchedules]="activitySchedules$ | async"></app-activity-schedule-overview-list>